import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'loadable-image',
  styleUrl: 'loadable-image.scss'
})
export class LoadableImage {

  @Prop() src: string;
  @Prop() alt?: string;
  @Prop() fallback?: string;
  @Prop() classes?: string;
  @Prop() loadedClass = 'image-is-loaded';
  @Prop() errorClass = 'image-has-error';

  private ref?: HTMLImageElement;

  componentDidLoad(): void {
    this.ref.onload = () => {
      if (this.loadedClass) {
        this.ref.classList.add(this.loadedClass, 'opacity--1');
      }
    };
    this.ref.onerror = () => {
      this.ref.classList.add(this.errorClass);
    }
  }

  render() {
    return (
      <img
        loading='eager'
        ref={ref => this.ref = ref}
        src={this.src}
        alt={this.alt}
        class={`opacity--0 transition--opacity duration--2 speed--1 ${this.classes}`}
      />
    );
  }

}
